<template>
  <div :class="className" @click="$emit('select')">
    <div :class="innerClassName">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardBase",
  props: {
    className: {
      type: String,
      default: "bg-white mt-3 mx-2"
    },
    innerClassName: {
      type: String,
      default: "inline-block w-full"
    }
  }
};
</script>

<style scoped></style>
